{
  "030cd98636706bfc": "Failed to delete tier",
  "041a6694b3bb1286": "Shifts created within the threshold hours of start time will have the listed charge differential added on top of the Workplace Base Charge.",
  "0e48ffeec1f32305": "Shifts created within the threshold of start time will have the charge differential added on top of the Workplace Base Charge.",
  "1428ca351bbee731": "Legacy rush fee applies until a Rush Fee Schedule tier is added",
  "19766ed6ccb2f4a3": "Cancel",
  "1d286cfa8b050852": "No tiers configured. Add one to start applying lead-time charge differentials.",
  "29615b6c84d469a4": "Between {{minimumHours}} and {{maximumHours}} hours.",
  "3f5ac997aacafd3b": "Charge differential on top of base charge",
  "45ef29b75657779f": "Failed to add tier",
  "4759498ac2a719c6": "Create",
  "63cc42e756e0dfad": "Failed to load tiers. Try refreshing.",
  "6ca7478fe7384fbe": "Between {{minimumPercent}}% and {{maximumPercent}}%.",
  "7d2f6a7754d58b7b": "+ Add tier",
  "89c3016595a8ae9d": "e.g. 12",
  "8ba512b5611a0b76": "Shift Rush Fee Schedule",
  "8c00bdc065aac77d": "Tier added",
  "98167f67ad7f2ad1": "Add tier",
  "a9ffa37c57370176": "Threshold (hours)",
  "da7d002ac58c3013": "Tier deleted",
  "e2d0a54968ead24e": "Delete",
  "e6d53f2e5db0aed7": "e.g. 5"
}
